module.exports = __webpack_public_path__ + "img/icon-ganyu.83887df9.webp";